import React from "react";
import ErrorOrder from "../components/order/ErrorOrder";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function ErrorOrderPage() {

  return (
    <div>
      <TitleUpdater />
      <ErrorOrder />
    </div>
  );
}
